import { CONTRACT_BASE_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import {
  CONTRACT_BALANCE_PATH,
  CONTRACT_PATH,
  EXTENRAL_CONTRACT_PATH,
} from "../contract/constants";
import { WALLET_PATH } from "./constants";
import {
  WalletAmountsResponseData,
  AmountsResponseData,
  WithdrawalRequest,
  WithdrawalResponse,
  WithdrawalHistoryResponse,
} from "./models";

const defaultProvide = async () => await getToken();

export const getTotalOrganizationWalletAmounts = (
  organizationCode: string
): Promise<WalletAmountsResponseData> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_BASE_URL}${EXTENRAL_CONTRACT_PATH}/organization/${organizationCode}/wallet-amounts`,
    "GET",
    defaultProvide
  );
  return fetchRequest(descriptor, null);
};

export const getAmounts = (id: string): Promise<AmountsResponseData> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_BASE_URL}${WALLET_PATH}/${id}/amounts`,
    "GET",
    defaultProvide
  );
  return fetchRequest(descriptor, null);
};

// Add wallet grouping-history fetcher
export interface WalletGroupingHistoryResponse {
  data: any; // TODO: Replace 'any' with the actual response structure if known
}

export const getTotalOrganizationWalletGroupingHistory = (
  organizationCode: string,
  size = 10,
  page = 0
): Promise<WalletGroupingHistoryResponse> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_BASE_URL}${EXTENRAL_CONTRACT_PATH}/organization/${organizationCode}/grouping-wallet-history?size=${size}&page=${page}`,
    "GET",
    defaultProvide
  );
  return fetchRequest(descriptor, null);
};

// Add withdrawal API
export const createOrganizationWithdrawalApi = (
  data: WithdrawalRequest
): Promise<WithdrawalResponse> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_BASE_URL}payments/withdrawal/`,
    "POST",
    defaultProvide
  );
  return fetchRequest(descriptor, data);
};

// Add withdrawal history API
export const getOrganizationWithdrawalHistory = (
  organizationCode: string,
  size = 10,
  page = 0
): Promise<WithdrawalHistoryResponse> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_BASE_URL}payments/withdrawal/organization/${organizationCode}?size=${size}&page=${page}`,
    "GET",
    defaultProvide
  );
  return fetchRequest(descriptor, null);
};

export const getOrganizationWalletAmounts = (
  orgAdminId: string
): Promise<WalletAmountsResponseData> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_BASE_URL}${CONTRACT_BALANCE_PATH}/user/${orgAdminId}/wallet-amounts`,
    "GET",
    defaultProvide
  );
  return fetchRequest(descriptor, null);
};

// Add wallet grouping-history fetcher
export interface WalletGroupingHistoryResponse {
  data: any; // TODO: Replace 'any' with the actual response structure if known
}

export const getOrganizationWalletGroupingHistory = (
  orgAdminId: string,
  size = 10,
  page = 0
): Promise<WalletGroupingHistoryResponse> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_BASE_URL}${CONTRACT_PATH}/user/${orgAdminId}/grouping-wallet-history?size=${size}&page=${page}`,
    "GET",
    defaultProvide
  );
  return fetchRequest(descriptor, null);
};
